<template>
  <div id="map">
    <div class="overlay-loading" ref="loadingOverlay">
      <div class="loading_container">
        <img class="loading_img" src="../../public/img/logo/loading.gif" />
      </div>
    </div>
    <div class="overlay-popup" ref="vehicleOverlay">
      <!-- <div v-show="isShow" class="overlay-popup" ref="vehicleOverlay"> -->
      <div class="title_bar text-white">
        <div class="title_container">
          <div class="logo_box">
            <div class="logo" :style="brandIconBg(carData.brand)"></div>
          </div>
          <div>
            <div class="title_item sub_font">{{ carData.num }}</div>
            <div class="title_item">{{ carData.model }} {{ carData.year }}</div>
          </div>
          <div class="state_box">
            <div
              class="state"
              :style="stateIconBg(carData.bsoc, carData.c_state, carData.brk)"
            ></div>
          </div>
        </div>
      </div>
      <div class="info_line">
        <img class="info_img" src="../../public/img/infoIcon/c_date.png" />
        <div class="info_title">정보발생일시</div>
        <div class="info_data">{{ carData.c_date }}</div>
      </div>

      <div class="info_line">
        <img class="info_img" src="../../public/img/infoIcon/t_dist.png" />
        <div class="info_title">주행거리</div>
        <div class="info_data">{{ carData.t_dist | comma }}Km</div>
      </div>
      <div class="info_line">
        <img class="info_img" src="../../public/img/infoIcon/soc.png" />
        <div class="info_title">SOC</div>
        <div class="info_data">{{ carData.bsoc }}%</div>
      </div>
      <div class="info_line">
        <img class="info_img" src="../../public/img/infoIcon/bacc.png" />
        <div class="info_title">누적 충전 전력량</div>
        <div class="info_data">{{ carData.bacp }}kWh</div>
      </div>
      <div class="info_line">
        <img class="info_img" src="../../public/img/infoIcon/bcdc.png" />
        <div class="info_title">누적 소비 전력량</div>
        <div class="info_data">{{ carData.badp }}kWh</div>
      </div>
      <div class="info_line">
        <img class="info_img" src="../../public/img/infoIcon/soh.png" />
        <div class="info_title">SOH</div>
        <div class="info_data">{{ carData.bsoh }}%</div>
      </div>
      <div class="info_line">
        <img class="info_img" src="../../public/img/infoIcon/dtc.png" />
        <div class="info_title">고장코드</div>
        <div class="info_data">없음</div>
      </div>
      <div class="info_line">
        <img class="info_img" src="../../public/img/infoIcon/co2.png" />
        <div class="info_title">탄소 절감량</div>
        <div class="info_data">
          {{
            ((carData.t_dist * 181 - carData.badp * 424) / 1000000).toFixed(3)
          }}t
        </div>
      </div>
      <a class="close_btn text-white" href="#" @click.prevent="closeModal()">
        <i class="close_btn_icon fa-solid fa-xmark"></i>
      </a>
    </div>
  </div>
</template>

<script>
import ax from "@/api/car";
import "@/filter/common";
import brandIconBg from "@/mixin/brandIconBg";
import stateIconBg from "@/mixin/stateIconBg";
import carNumber from "@/mixin/carNumber";
import counterClockWise from "@/mixin/counterClockWise";
import locationPos from "@/mixin/locationPos";
import store from "@/store";

export default {
  mixins: [brandIconBg, stateIconBg, counterClockWise, carNumber, locationPos],

  props: {
    monList: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      // x : 경도 y: 위도
      // kakaomapAPI : new kakao.maps.LatLng(y, x)

      mapCenter: { x: 126.588641, y: 33.398883 }, // 초기 지도 중심좌표
      autoModalMapCenter: { x: 126.45136, y: 33.39868 }, // 초기 지도 중심좌표
      autoModalPos: { x: 126.06945, y: 33.4591 }, // 초기 지도 중심좌표

      mapLevel: 9, // 초기 지도 레벨(변동)
      autoModalMapLevel: 9, // 초기 지도 레벨(변동X)

      center: { x: 126.539392, y: 33.396194 }, // 지도 중심좌표

      errCenter: { x: 126.571547, y: 33.442352 }, // 이탈차량 좌표

      carInfo: {
        baccTitle: "누적 충전 전류량",
        bcdcTitle: "누적 소비 전류량"
      },

      carData: {
        cseq: null,
        num: null,
        brand: null,
        model: null,
        year: null,
        id: null,
        idx: null,
        gps_x: null,
        gps_y: null,
        t_dist: null,
        bsoc: null,
        bsoh: null,
        bacp: null,
        badp: null,
        brk: null,
        c_state: null,
        c_date: null
      },

      checkMarker: null,
      markers: [],
      loadingOverlay: null,
      overlay: null,
      isShow: false,
      isMove: false,
      autoModalIdx: 0,
      isLoad: true
    };
  },

  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement("script");
      /* global kakao */
      script.onload = () => kakao.maps.load(this.initMap);
      script.src =
        "http://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=1012b4d944d2e6b81ae0a5f9a1660cd5";
      document.head.appendChild(script);
    }
  },

  methods: {
    initMap() {
      var container = document.getElementById("map");
      var options = {
        center: new kakao.maps.LatLng(this.mapCenter.y, this.mapCenter.x),
        level: this.mapLevel,
        disableDoubleClickZoom: true
      };

      this.map = new kakao.maps.Map(container, options);

      this.map.setMapTypeId(kakao.maps.MapTypeId.ROADMAP);

      this.openLoadingOverlay();
    },

    setMarker() {
      for (let i = 0; i < this.monList.length; i++) {
        // 기존 마커 클리어
        if (this.markers[i] != null) this.markers[i].setMap(null);

        var imgSrc;
        var imgSize = new kakao.maps.Size(40, 45);
        var imgOpt = { offset: new kakao.maps.Point(19, 38) };

        if (0 <= this.monList[i].bsoc && this.monList[i].bsoc <= 20) {
          if (
            this.monList[i].brk == 0 &&
            (this.monList[i].c_state == "01" || this.monList[i].c_state == "00")
          ) {
            imgSrc = require(`../../public/img/mapImg/row-discharging-start.png`);
          } else if (
            this.monList[i].brk == 1 &&
            this.monList[i].c_state != "01" &&
            this.monList[i].c_state != "00"
          ) {
            imgSrc = require(`../../public/img/mapImg/row-charging-end.png`);
          } else if (
            this.monList[i].brk == 0 &&
            this.monList[i].c_state != "01" &&
            this.monList[i].c_state != "00"
          ) {
            imgSrc = require(`../../public/img/mapImg/row-charging-start.png`);
          } else {
            imgSrc = require(`../../public/img/mapImg/row-discharging-end.png`);
          }
        } else if (20 < this.monList[i].bsoc && this.monList[i].bsoc <= 60) {
          if (
            this.monList[i].brk == 0 &&
            (this.monList[i].c_state == "01" || this.monList[i].c_state == "00")
          ) {
            imgSrc = require(`../../public/img/mapImg/middle-discharging-start.png`);
          } else if (
            this.monList[i].brk == 1 &&
            this.monList[i].c_state != "01" &&
            this.monList[i].c_state != "00"
          ) {
            imgSrc = require(`../../public/img/mapImg/middle-charging-end.png`);
          } else if (
            this.monList[i].brk == 0 &&
            this.monList[i].c_state != "01" &&
            this.monList[i].c_state != "00"
          ) {
            imgSrc = require(`../../public/img/mapImg/middle-charging-start.png`);
          } else {
            imgSrc = require(`../../public/img/mapImg/middle-discharging-end.png`);
          }
        } else if (60 < this.monList[i].bsoc && this.monList[i].bsoc <= 100) {
          if (
            this.monList[i].brk == 0 &&
            (this.monList[i].c_state == "01" || this.monList[i].c_state == "00")
          ) {
            imgSrc = require(`../../public/img/mapImg/high-discharging-start.png`);
          } else if (
            this.monList[i].brk == 1 &&
            this.monList[i].c_state != "01" &&
            this.monList[i].c_state != "00"
          ) {
            imgSrc = require(`../../public/img/mapImg/high-charging-end.png`);
          } else if (
            this.monList[i].brk == 0 &&
            this.monList[i].c_state != "01" &&
            this.monList[i].c_state != "00"
          ) {
            imgSrc = require(`../../public/img/mapImg/high-charging-start.png`);
          } else {
            imgSrc = require(`../../public/img/mapImg/high-discharging-end.png`);
          }
        }

        var markerImage = new kakao.maps.MarkerImage(imgSrc, imgSize, imgOpt);

        // 마커 객체 생성 & 마커 객체를 배열에 저장
        this.markers[i] = new kakao.maps.Marker({
          map: this.map,
          position: new kakao.maps.LatLng(
            this.monList[i].gps_y,
            this.monList[i].gps_x
          ), // 마커를 표시할 위치
          title: this.carNumberMask(this.monList[i].num),
          //title: this.monList[i].num,

          image: markerImage
        });

        // 이탈좌표일 경우 true 반환
        let cPoint = { x: this.monList[i].gps_x, y: this.monList[i].gps_y };
        let isCross = this.carPointCheck(cPoint);

        if (isCross) {
          // todo : 좌표이탈 시, 가까운 도로로 배치
          this.markers[i].setPosition(
            new kakao.maps.LatLng(this.errCenter.y, this.errCenter.x)
          ); // 좌표이탈 시 this.errCenter 으로 지정
          this.monList[i].gps_x = this.errCenter.x;
          this.monList[i].gps_y = this.errCenter.y;
        }

        // 마커에 클릭이벤트 추가
        kakao.maps.event.addListener(this.markers[i], "click", () => {
          this.openModal(i);
        });

        // 마커를 지도상에 표기
        this.markers[i].setMap(this.map);
      }

      kakao.maps.event.addListener(this.map, "dragend", () => {
        this.setMapCenter();
        // this.callEventLog();
      });

      kakao.maps.event.addListener(this.map, "zoom_changed", () => {
        this.setMapLevel();
        // this.callEventLog();
      });

      // 최초 openModal()시 css오류방지
      if (!this.isShow) {
        this.openModal(0);
        this.closeModal();
        this.isShow = true;
        this.closeLoadingOverlay();
      }
    },

    openLoadingOverlay() {
      this.map.setDraggable(false);
      this.map.setZoomable(false);

      this.loadingOverlay = new kakao.maps.CustomOverlay({
        content: this.$refs.loadingOverlay,
        map: this.map,
        position: new kakao.maps.LatLng(this.mapCenter.y, this.mapCenter.x),
        zIndex: 100
      });

      this.loadingOverlay.setMap(this.map);
    },

    closeLoadingOverlay() {
      this.map.setDraggable(true);
      this.map.setZoomable(true);

      this.loadingOverlay.setMap(null);
    },

    openModal(i, x, y) {
      this.carIdx = i;
      var modalPos = { x: this.mapCenter.x, y: this.mapCenter.y };

      // auto modal 일시, map center & level 고정
      if (store.getters.autoModalState) {
        modalPos.x = this.autoModalPos.x;
        modalPos.y = this.autoModalPos.y;

        this.map.setLevel(this.autoModalMapLevel);
        this.map.setCenter(
          new kakao.maps.LatLng(
            this.autoModalMapCenter.y,
            this.autoModalMapCenter.x
          )
        );
      }

      if (x != null && y != null) {
        modalPos = { x: x, y: y}
      }

      // 차량정보 삽입
      this.insertCarData("init", this.monList[i]);

      // 최신정보 읽어오기
      // this.setLastData(this.carData.id);

      // 커스텀 오버레이 생성
      this.overlay = new kakao.maps.CustomOverlay({
        content: this.$refs.vehicleOverlay,
        map: this.map,
        position: new kakao.maps.LatLng(modalPos.y, modalPos.x),
        zIndex: 100
      });

      this.overlay.setMap(this.map);
    },

    closeModal() {
      this.overlay.setMap(null);
      this.carIdx = null;
    },

    setLastData() {
      ax.vdbLastData(this.carData.id, rs => {
        if (rs) {
          this.insertCarData("update", rs.item[0]);
        } else {
          this.$notify({
            group: "alert",
            type: "warn",
            title: "경고",
            text: "데이터를 읽어오지 못했습니다."
          });
        }
      });
    },

    insertCarData(flag, data) {
      switch (flag) {
        case "init":
          this.carData.id = data.id;

          if (store.getters.userAuth == "admin") {
            this.carData.num = data.num;
          } else {
            this.carData.num = this.carNumberMask(data.num);
          }

          this.carData.brand = data.brand;
          this.carData.model = data.model;
          this.carData.year = data.year;
          this.carData.t_dist = data.t_dist;
          this.carData.bsoc = data.bsoc;
          this.carData.bacp = data.bacp;
          this.carData.badp = data.badp;
          this.carData.bsoh = data.bsoh;
          this.carData.c_state = data.c_state;
          this.carData.brk = data.brk;
          this.carData.c_date = data.c_date;
          break;

        case "update":
          this.carData.t_dist = data.t_dist;
          this.carData.bsoc = data.bsoc;
          this.carData.bacp = data.bacp;
          this.carData.badp = data.badp;
          this.carData.bsoh = data.bsoh;
          // this.carData.c_state    = data.c_state;
          // this.carData.evr        = data.evr;
          this.carData.c_date = data.c_date;
          break;
      }
    },

    setMapCenter() {
      var latlng = this.map.getCenter();
      this.mapCenter.x = latlng.getLng();
      this.mapCenter.y = latlng.getLat();
    },

    setMapLevel() {
      this.mapLevel = this.map.getLevel();
      this.setMapCenter();
    },

    callEventLog() {
      console.log("이벤트 : " + this.mapLevel);
      console.log("이벤트 : " + this.mapCenter.x + ", " + this.mapCenter.y);
    },

    setCheckMarker(autoModalIdx) {
      if (this.checkMarker != null) this.checkMarker.setMap(null);

      var imgSrc = require(`../../public/img/mapImg/check.png`);
      var imgSize = new kakao.maps.Size(60, 60);
      var imgOpt = { offset: new kakao.maps.Point(28, 45) };

      var markerImage = new kakao.maps.MarkerImage(imgSrc, imgSize, imgOpt);

      // 마커 객체 생성 & 마커 객체를 배열에 저장
      this.checkMarker = new kakao.maps.Marker({
        map: this.map,
        position: new kakao.maps.LatLng(
          this.monList[autoModalIdx].gps_y,
          this.monList[autoModalIdx].gps_x
        ), // 마커를 표시할 위치
        title: this.carNumberMask(this.monList[autoModalIdx].num),
        image: markerImage
      });

      // 마커를 지도상에 표기
      this.checkMarker.setMap(this.map);
    },

    openAutoModal() {
      // console.log("openAutoModal: " + this.autoModalIdx);

      this.closeModal();

      if (this.autoModalIdx == 0) {
        this.openModal(0);
        this.closeModal();
      }

      this.openModal(this.autoModalIdx);

      this.setCheckMarker(this.autoModalIdx);

      this.autoModalIdx += 1;

      if (this.autoModalIdx >= this.monList.length) this.autoModalIdx = 0;
    }
  },

  computed: {
    location() {
      return store.getters.locationState;
    },

    monitoringId() {
      return store.getters.monitoringIdState;
    }
  },

  watch: {
    monList() {
      this.setMarker();

      if (store.getters.autoModalState && this.isShow) {
        this.openAutoModal();
      } else if (!store.getters.autoModalState && this.checkMarker != null) {
        this.checkMarker.setMap(null);
        this.checkMarker = null;
      }
    },

    location(value) {
      if (value != null) {
        this.mapCenter = this.getLocationPos(value);
        
        // 모니터링 center 좌표 변경
        this.map.setCenter(
          new kakao.maps.LatLng(this.mapCenter.y, this.mapCenter.x)
        );
  
        // 모니터링 레벨 변경
        this.map.setLevel(this.autoModalMapLevel);
      }
    },

    monitoringId(value) {
      let carIndex = null

      if(value != null) {
        for(let i=0; i<this.monList.length; i++) {
          if(this.monList[i].id == value) {
            carIndex = i;
            break;
          }
        }
  
        if(carIndex != null) {
          // 모달 오픈
          this.openModal(carIndex, this.monList[carIndex].gps_x, this.monList[carIndex].gps_y)
          
          // 모니터링 center 좌표 변경
          this.map.setCenter(
            new kakao.maps.LatLng(this.monList[carIndex].gps_y, this.monList[carIndex].gps_x)
          );

          store.dispatch("locationCtrl", { location:  null });
          store.dispatch("monitorCtrl", { id:  null });
        } else {
          console.log(value, '단말기를 찾을 수 없습니다 :<');

          store.dispatch("monitorCtrl", { id:  null });
        }
      }
    }
  }
};
</script>

<style lang="scss">
#map {
  width: 100%;
  height: 100%;
}
.overlay-loading {
  background-color: white;
  width: 150px;
  height: 150px;
  border-radius: 35px;
  box-shadow: 0 2px 43px 2000px rgb(0 0 0 / 35%);

  .loading_container {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .loading_img {
    width: 80px;
    height: 80px;
  }
}

.overlay-popup {
  background-color: white;
  width: 350px;
  height: 350px;
  border-radius: 35px;
  box-shadow: 0 2px 43px -4px rgb(0 0 0 / 35%);

  .title_bar {
    margin-bottom: 15px;
    background-color: #13a3f3;
    height: 65px;
    border-radius: 35px 35px 0 0;
    padding-top: 10px;
    padding-left: 5px;
  }

  .title_container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: left;
    align-items: center;
    margin-left: 20px;

    .logo_box {
      width: 50px;
      padding-top: 5px;
      text-align: center;

      .logo {
        display: inline-block;
        height: 40px;
        width: 40px;
        background: {
          image: url("/img/company/1.png");
          repeat: no-repeat;
          position: center center;
        }
      }
    }

    .title_item {
      padding-left: 10px;
    }
  }

  .state_box {
    position: absolute;
    margin-left: 60%;
    width: 80px;
    height: 40px;
    text-align: center;

    .state {
      display: inline-block;
      width: 100%;
      height: 100%;
      background-size: 80px;
      background: {
        image: url("/img/state/high-discharging-start.png");
        repeat: no-repeat;
        position: center center;
      }
    }
  }

  .close_btn {
    position: absolute;
    top: 0;
    left: 100%;
    transform: translate(-60%, -10%);
    background-color: #f31313;
    border-radius: 100%;

    .close_btn_icon {
      font-size: 0.8rem;
      padding: 0.7rem 0.8rem 0.7rem 0.8rem;
    }
  }

  .close_btn:hover {
    background-color: #cc0202;
  }

  .info_line {
    padding-left: 15%;
    padding-top: 7px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: left;
    align-items: center;

    .info_img {
      width: 24px;
      height: 24px;
      margin-right: 6px;
    }

    .info_title {
      font-weight: 600;
      margin-right: 7px;
      font-size: 14px;
    }
  }

  .update_btn {
    text-align: center;
    margin-top: 25px;
  }
}
</style>
